// Retained drinks use the existing Spanish menu as the common price/size source.
// Lassi prices come from the owner's October 2026 PDFs. Chai is in those PDFs
// and is deliberately omitted from the retained coffee/tea list.
const item = (es, en, price, description = null, allergens = []) => ({
  name: { es, en }, price, description, allergens,
});
const group = (es, en, items, measures = false) => ({
  title: { es, en }, items, measures,
});

export const drinks = [
  group('Refrescos con gas', 'Sparkling soft drinks', [
    item('Sprite (200 ml)', 'Sprite (200 ml)', 1.75),
    item('Tónica (200 ml)', 'Tonic water (200 ml)', 2),
    item('Coca-Cola (237 ml)', 'Coca-Cola (237 ml)', 1.75),
    item('Coca-Cola Zero (237 ml)', 'Coca-Cola Zero (237 ml)', 1.75),
    item('Coca-Cola Zero Zero (237 ml)', 'Coca-Cola Zero Zero (237 ml)', 1.75),
    item('Fanta Naranja (237 ml)', 'Orange Fanta (237 ml)', 1.75),
    item('Fanta Limón (237 ml)', 'Lemon Fanta (237 ml)', 1.75),
    item('Ginger Ale (237 ml)', 'Ginger Ale (237 ml)', 2),
    item('Appletiser (237 ml)', 'Appletiser (237 ml)', 2),
    item('Limca (300 ml)', 'Limca (300 ml)', 3),
    item('Thums Up (300 ml)', 'Thums Up (300 ml)', 3),
  ]),
  group('Refrescos sin gas', 'Still soft drinks', [
    item('Zumo de melocotón (200 ml)', 'Peach juice (200 ml)', 1.75),
    item('Zumo de piña (200 ml)', 'Pineapple juice (200 ml)', 1.75),
    item('Zumo de naranja (200 ml)', 'Orange juice (200 ml)', 1.75),
    item('Nestea Limón (300 ml)', 'Lemon Nestea (300 ml)', 2.25),
    item('Aquarius Limón (300 ml)', 'Lemon Aquarius (300 ml)', 2.25),
    item('Aquarius Naranja (300 ml)', 'Orange Aquarius (300 ml)', 2.25),
    item('Zumo de mango (350 ml)', 'Mango juice (350 ml)', 3),
    item('Zumo de caña de azúcar (350 ml)', 'Sugar cane juice (350 ml)', 3),
    item('Zumo de tamarindo (350 ml)', 'Tamarind juice (350 ml)', 3),
    item('Zumo de coco (350 ml)', 'Coconut juice (350 ml)', 3),
    item('Zumo de coco tostado (350 ml)', 'Roasted coconut juice (350 ml)', 3),
    item('Zumo de guayaba (350 ml)', 'Guava juice (350 ml)', 3),
    item('Zumo de granada (350 ml)', 'Pomegranate juice (350 ml)', 3),
    item('Zumo de maracuyá (350 ml)', 'Passion fruit juice (350 ml)', 3),
    item('Zumo de lychee (350 ml)', 'Lychee juice (350 ml)', 3),
  ]),
  group('Lassis y bebidas de la India', 'Lassis & Indian drinks', [
    item('Lassi dulce', 'Sweet Lassi', 3.5, null, ['nuts', 'milk']),
    item('Lassi salado', 'Salted Lassi', 3.5, null, ['nuts', 'milk']),
    item('Lassi de coco', 'Coconut Lassi', 3.75, null, ['nuts', 'milk']),
    item('Lassi de mango', 'Mango Lassi', 4, null, ['nuts', 'milk']),
    item('Milk Rose Sharbat', 'Milk Rose Sharbat', 3.75, null, ['nuts', 'milk']),
  ]),
  group('Agua', 'Water', [
    item('Agua mineral (500 ml)', 'Mineral water (500 ml)', 1.75),
    item('Agua mineral (1000 ml)', 'Mineral water (1000 ml)', 2.75),
    item('Agua con gas (500 ml)', 'Sparkling mineral water (500 ml)', 1.75),
  ]),
  group('Combinados listos para beber', 'Ready-to-drink alcoholic drinks', [
    item('Sidra Ladrón de Manzanas (250 ml)', 'Ladrón de Manzanas apple cider (250 ml)', 2.25),
    item('Tinto de Verano La Casera (275 ml)', 'La Casera Tinto de Verano (275 ml)', 2.5),
    item('Tinto con Limón La Casera (275 ml)', 'La Casera lemon Tinto de Verano (275 ml)', 2.5),
  ]),
  group('Vino y cerveza', 'Wine & beer', [
    item('Cerveza de barril', 'Draught beer', 1.75),
    item('Copa de vino', 'Glass of wine', { es: 'Consultar al equipo', en: 'Ask our team' }),
    item('Cerveza Radler (333 ml)', 'Radler beer (333 ml)', 2.5),
    item('Cerveza sin alcohol / 0,0 % (333 ml)', 'Alcohol-free / 0.0% beer (333 ml)', 2.5),
    item('Cerveza sin gluten (333 ml)', 'Gluten-free beer (333 ml)', 2.5),
    item('Alhambra Reserva 1925 Verde (333 ml)', 'Alhambra Reserva 1925 green bottle (333 ml)', 3),
    item('Alhambra Reserva 1925 Roja (333 ml)', 'Alhambra Reserva 1925 red bottle (333 ml)', 3),
    item('Estrella Galicia (333 ml)', 'Estrella Galicia (333 ml)', 3),
    item('Estrella Galicia 1906 (333 ml)', 'Estrella Galicia 1906 (333 ml)', 3.5),
    item('Cobra (333 ml)', 'Cobra (333 ml)', 3.5),
    item('Kingfisher (333 ml)', 'Kingfisher (333 ml)', 3.5),
  ]),
  group('Ginebra', 'Gin', [
    item('Beefeater', 'Beefeater', [4, 7.5]),
    item('Larios 12', 'Larios 12', [4, 7]),
    item('Puerto de Indias Fresa', 'Puerto de Indias Strawberry', [4.5, 8]),
    item('Bombay Sapphire', 'Bombay Sapphire', [5, 9]),
    item('Beefeater 24', 'Beefeater 24', [5, 9]),
    item('Brockmans', 'Brockmans', [6, 11]),
  ], true),
  group('Vodka', 'Vodka', [
    item('Smirnoff', 'Smirnoff', [4, 7]),
    item('Absolut', 'Absolut', [4.5, 8]),
    item('Cîroc', 'Cîroc', [5, 9]),
    item('Grey Goose', 'Grey Goose', [6, 11]),
  ], true),
  group('Ron dorado', 'Dark rum', [
    item('Legendario', 'Legendario', [4, 7]),
    item('Barceló', 'Barceló', [4.5, 8]),
    item('Captain Morgan', 'Captain Morgan', [4.5, 8]),
  ], true),
  group('Ron blanco', 'White rum', [
    item('Havana 3', 'Havana 3', [4, 7]),
    item('Bacardí', 'Bacardí', [4, 7]),
  ], true),
  group('Tequila', 'Tequila', [
    item('José Cuervo Silver', 'José Cuervo Silver', [3, 5]),
    item('José Cuervo Reposado', 'José Cuervo Reposado', [3, 5]),
  ], true),
  group('Whisky', 'Whisky', [
    item('Cutty Sark', 'Cutty Sark', [4, 7]),
    item('Ballantine’s', 'Ballantine’s', [4, 7]),
    item('Johnnie Walker Red Label', 'Johnnie Walker Red Label', [4, 7]),
    item('Johnnie Walker Black Label', 'Johnnie Walker Black Label', [5, 9]),
    item('Chivas Regal', 'Chivas Regal', [5, 9]),
  ], true),
  group('Bourbon', 'Bourbon', [item('Jack Daniel’s', 'Jack Daniel’s', [5, 9])], true),
  group('Whisky de malta', 'Single malt whisky', [item('Glenfiddich 12', 'Glenfiddich 12', [6, 11])], true),
  group('Brandy', 'Brandy', [item('Terry', 'Terry', [4, 9]), item('Carlos III', 'Carlos III', [5, 9])], true),
  group('Vermut', 'Vermouth', [
    item('Martini Rosso', 'Martini Rosso', [4, 7]),
    item('Martini Rosato', 'Martini Rosato', [4, 7]),
    item('Martini Bianco', 'Martini Bianco', [4, 7]),
    item('Martini Extra Dry', 'Martini Extra Dry', [4, 7]),
  ], true),
];

export const coffee = [group('Cafés, tés y chupitos', 'Coffee, tea & shots', [
  item('Infusiones', 'Tea & herbal infusions', 1.75, {
    es: 'Té rojo, té verde, té negro con vainilla y caramelo, té negro con frutas del bosque, infusión de jengibre con limón, manzanilla, menta-poleo y tila.',
    en: 'Red tea, green tea, vanilla and caramel black tea, wild berry black tea, ginger and lemon infusion, chamomile, mint-pennyroyal and linden tea.',
  }),
  item('Café', 'Coffee', 1.75, {
    es: 'Espresso, café largo, cortado o café con leche.',
    en: 'Espresso, long coffee, espresso macchiato or coffee with milk.',
  }, ['milk', 'soy']),
  item('Descafeinado', 'Decaffeinated coffee', 1.75, {
    es: 'Espresso, cortado o café con leche.',
    en: 'Espresso, espresso macchiato or coffee with milk.',
  }, ['milk', 'soy']),
  item('Café especial', 'Special coffee', 2.5, {
    es: 'Cappuccino, Chococino o Latte macchiato.',
    en: 'Cappuccino, Chococino or Latte macchiato.',
  }, ['milk', 'soy']),
  item('Chupitos', 'Shots', 2, {
    es: 'Vodka caramelo, vodka fresa, licor de hierbas, pacharán, limoncello, licor de piruleta, licor de manzana o licor de melocotón.',
    en: 'Caramel vodka, strawberry vodka, herbal liqueur, pacharán, limoncello, lollipop liqueur, apple liqueur or peach liqueur.',
  }, ['sulphites']),
  item('Chupitos premium', 'Premium shots', 2.5, { es: 'Jägermeister.', en: 'Jägermeister.' }, ['sulphites']),
])];



// WEBPACK FOOTER //
// ./src/data/menuDrinks.js